import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

// Eager metadata registration; the render component (ObjectWidget) code-splits
// into its own tpl-object-widget chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'object-widget',
    name: 'Object View',
    description: 'Use this to show details about a specific item',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-object-widget" */ "./ObjectWidget")),
    canDragDropFields: true,
    icon: ['fas', 'credit-card-blank'],
    complexity: 'advanced',
    autoHieght: true
});
